import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Constants from "../utils/Constants";
import AuthorizedUser from "../utils/AuthorizedUser";
import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import AccountFilterField from "./AccountFilterField";
import FilterSelect from "./FilterSelect";

import {
	Grid,
	withWidth
} from '@material-ui/core';

class Filterer extends Component {
	constructor(props, context) {
		super(props, context);

		let defaultFilter = {
			selectedSources: [],
			selectedAccounts: [],
			selectedTopics: []
		};

		this.state = {
			sources: null,
			accounts: null,
			topics: null,
			filter: defaultFilter,
			defaultFilter: Object.assign({}, defaultFilter)
		};

		this.executeFilter = this.executeFilter.bind(this);
	}

	componentDidMount() {
		let {topics} = this.props;
		if (topics && topics.length) {
			this.setState({topics: topics}, this.setupFilters);
		} else {
			this.setupFilters();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		let {topics} = this.props;
		if (JSON.stringify(prevProps.topics) !== JSON.stringify(topics)) {
			this.setState({topics: topics}, this.setupFilters);
		}
	}

	getAccountOptions(authenticatedUser) {
		let opts,
			localStorageSelections,
			localStorageObj = localStorage.getItem(AccountFilterField.stickyLocalStorageKey);

		if (AuthorizedUser.hasStickyAccountFilter(authenticatedUser) && localStorageObj !== null) {
			localStorageSelections = JSON.parse(localStorageObj)[authenticatedUser.id];
		}

		opts = authenticatedUser.childAccounts.map(opt => {
			opt.selected = localStorageSelections ? localStorageSelections.findIndex(item => opt.id === item.id) !== -1 : true;
			return opt;
		});

		return opts;
	}

	setupFilters() {
		let {topics} = this.state,
			{authenticatedUser} = this.props,
			accounts = this.getAccountOptions(authenticatedUser),
			sources = Constants.SOURCES.getAuthorized(authenticatedUser),
			filter = {
				selectedAccounts: accounts,
				selectedSources: sources.map(item => item.id),
				selectedTopics: topics && topics.length ? topics.map(item => item.id) : []
			};

		this.setState({
			sources: sources,
			accounts: accounts,
			topics: topics,
			filter: filter,
			defaultFilter: filter
		});
	}

	filter(filterKey, stateKey, selected) {
		let obj = {},
			{filter} = this.state;

		if (JSON.stringify(filter[filterKey]) !== JSON.stringify(selected)) {
			obj[filterKey] = selected.length ? selected : this.state[stateKey].map(item => item.id);

			this.setState({
				filter: Object.assign({}, this.state.filter, obj)
			}, this.executeFilter);
		}
	}

	accountFilterChanged(option, name, selectAll, reset, array, defaultValue, setter, filteredSelectAll) {
		let accounts = [],
			defaults = defaultValue,
			// deep copy array because changing attributes on objects in array affects original array
			newArray = JSON.parse(JSON.stringify(array));

		if (!reset) {
			newArray.map(opt => {
				if (selectAll != null) {
					opt.selected = selectAll;
				} else if ((option && opt.id === option.id) || (filteredSelectAll === true && !opt.hidden)) {
					opt.selected = !opt.selected;
				}

				return opt;
			});

			if (JSON.stringify(newArray) !== JSON.stringify(array)) {
				newArray.forEach(opt => opt.selected ? accounts.push(opt.id) : null);
			}
		} else {
			if (defaults == null) {
				defaults = newArray;
				defaults.forEach(opt => opt.selected = true);
			}
			defaults.forEach(opt => accounts.push(opt.id));
		}

		this.setState({
			accounts: newArray,
			filter: {
				selectedAccounts: accounts
			}
		}, this.executeFilter);
	}

	buildQueryString(selected, filterKey) {
		let outputString = null;

		if (Array.isArray(selected)) {
			outputString = selected.join(",");
		} else if (!Array.isArray(selected)) {
			outputString = selected;
		}

		return outputString;
	}

	executeFilter() {
		let query = {},
			{executeFilterHandler} = this.props,
			{filter} = this.state,
			sourceString = this.buildQueryString(filter.selectedSources, "selectedSources"),
			accountString = this.buildQueryString(filter.selectedAccounts, "selectedAccounts"),
			topicString = this.buildQueryString(filter.selectedTopics, "selectedTopics");

		if (sourceString) {
			query.source = sourceString;
		}

		if (accountString) {
			query.account = accountString;
		}

		if (topicString) {
			query.topic = topicString;
		}

		executeFilterHandler(query);
	}

	render() {
		let {shouldReset, includeReset, width,
				defaultSourceSelections, defaultTopicSelections, authenticatedUser} = this.props,
			{sources, accounts, topics, defaultFilter} = this.state,
			hasMultipleSources = sources && sources.length > 1 ? true : false,
			hasMultipleAccounts = accounts && accounts.length > 1 ? true : false,
			atLeastSM = !width.includes("xs");

		return (
			<Grid container>
				{hasMultipleAccounts ?
					<Grid item>
						<AccountFilterField
							includeReset={atLeastSM}
							accountOptions={accounts}
							changeHandler={(option, name, selectAll, reset, filteredSelectAll) => {
								this.accountFilterChanged(option, name, selectAll, reset, accounts, null, null, filteredSelectAll);
							}}
							stickyFilterHandler={(localStorageKey, isSticky) => {
								let length,
									obj = {};

								obj[authenticatedUser.id] = accounts.filter(accnt => accnt.selected);
								length = obj[authenticatedUser.id].length;

								if (isSticky && length > 0) {
									localStorage.setItem(localStorageKey, JSON.stringify(obj));
								} else if (isSticky === false) {
									localStorage.removeItem(localStorageKey);
								}
							}} />
					</Grid> : null
				}
				{hasMultipleSources ?
					<Grid item>
						<FilterSelect
							includeSelectAll
							options={sources}
							menuTitle="Sources"
							selectAllTitle="All sources"
							shouldReset={shouldReset}
							includeReset={includeReset}
							defaultSelections={
								defaultSourceSelections && defaultSourceSelections.length ?
									defaultSourceSelections : defaultFilter && defaultFilter.selectedSources
							}
							handleUpdate={(selected) => this.filter("selectedSources", "sources", selected)} />
					</Grid> : null
				}
				<Grid item>
					<FilterSelect
						includeSelectAll
						options={topics || []}
						menuTitle="Topics"
						selectAllTitle="All topics"
						shouldReset={shouldReset}
						includeReset={includeReset}
						singleColumn={width.includes("xs")}
						defaultSelections={
							defaultTopicSelections && defaultTopicSelections.length ?
								defaultTopicSelections : defaultFilter && defaultFilter.selectedTopics
						}
						handleUpdate={(selected) => this.filter("selectedTopics", "topics", selected)} />
				</Grid>
			</Grid>
		);
	}
}

Filterer.defaultProps = {
	includeReset: true
};

Filterer.propTypes = {
	location: PropTypes.object.isRequired,
	executeFilterHandler: PropTypes.func.isRequired,
	authenticatedUser: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
	width: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
	topics: PropTypes.array,
	shouldReset: PropTypes.func,
	includeReset: PropTypes.bool,
	defaultSourceSelections: PropTypes.array,
	defaultTopicSelections: PropTypes.array,
	//defaultAccountSelections: PropTypes.array
	//defaultSearchParams: PropTypes.object
};

// eslint error
const dNameFunc = (props, ref) => (
	<AuthorizedUserContext.Consumer>
		{authenticatedUser => <Filterer {...props} authenticatedUser={authenticatedUser} ref={ref} />}
	</AuthorizedUserContext.Consumer>
);
dNameFunc.displayName = "Filterer";

export default withWidth()(React.forwardRef(dNameFunc));
